import { Flex } from 'theme-ui';

type Props = {
  badge: Queries.BadgeFragment;
};

export default function Badge({ badge }: Props) {
  if (!badge.text) return null;
  return (
    <Flex
      sx={{
        position: 'absolute',
        top: '30cqh',
        left: '-12.5cqh',
        zIndex: 1,
        pointerEvents: 'none',
        color: badge.textColor ?? 'white',
        background: badge.backgroundColor ?? 'black',
        transform: 'rotate(-45deg)',
        transformOrigin: '0 0',
        height: '12cqh',
        fontFamily: 'body',
        fontSize: badge.textSize === 'lg' ? '6cqw' : '3.3cqw',
        fontWeight: 500,
        lineHeight: 1.1,
        textTransform: 'uppercase',
        width: '60cqh',
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <span dangerouslySetInnerHTML={{ __html: badge.text }} />
    </Flex>
  );
}
